import { render } from "./NewProductBigud.vue?vue&type=template&id=73968f86&scoped=true"
import script from "./NewProductBigud.vue?vue&type=script&lang=js"
export * from "./NewProductBigud.vue?vue&type=script&lang=js"

import "./NewProductBigud.vue?vue&type=style&index=0&id=73968f86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73968f86"]])

export default __exports__